import axios from 'axios';
import { LS_PROCESSING_DATE } from '@/Contacts/components/import/config/new-flow.js'

export default {
  namespaced: true,
  state: {
    loading: false,
    error: null,
    hasError: false,
    success: true,
    hasFirstImportSession: false,
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setError(state, error) {
      state.error = error;
      state.hasError = !!error;
      state.success = !error;
    },
    setSuccess(state, success) {
      state.success = success;
    },
    clearMessages(state) {
      state.success = false;
      state.error = null;
      state.hasError = false;
      state.loading = false;
    },
    setHasFirstImportSession(state, value) {
      state.hasFirstImportSession = value;
    },
  },
  actions: {
    async startImportProcess({ commit, dispatch }, payload) {
      commit('setLoading', true);
      dispatch('trackInProgressImportProcess');

      try {
        await axios.post(`${process.env.VUE_APP_CONTACTS_MS_BASE_URL}/import`, payload);
        commit('setSuccess', true);
      } catch (error) {
        if (error.data && error.data.error) {
          commit('setError', error.data.error);
        } else {
          commit('setError', error);
        }
      }
      commit('setLoading', false);
    },
    trackInProgressImportProcess(store, dateTime) {
      const storedDate = localStorage.getItem(LS_PROCESSING_DATE);
      if (storedDate && !dateTime) {
        return
      }

      const trackDate = dateTime || (new Date()).getTime();
      localStorage.setItem(LS_PROCESSING_DATE, trackDate);
    },
    isFirstImportOnCurrentSession({ commit }) {
      commit('setHasFirstImportSession', true);
    },
  },
};
